<template>
  <div class="i-backup-salesforce-status-dropdown">
    <i-dropdown
      :label="label"
      v-model="value"
      :options="options"
      placeholder="All"
      :allow-empty="false"
      @input="onInput"
    />
  </div>
</template>

<script>
import IDropdown from "@/components/common/IDropdown.vue";

export default {
  name: "IBackupSalesforceStatusDropdown",
  components: {IDropdown},

  data() {
    return {
      options: [
        {label: "All", value: ''},
        {label: "Pending", value: 1},
        {label: "In progress", value: 2},
        {label: "Completed", value: 3},
        {label: "Failed", value: 4},
        {label: "Partially Completed", value: 6},
      ],
      value: '',
    }
  },

  props: {
    label: {
      type: String,
      default: 'Status',
    },
  },

  methods: {
    onInput(e) {
      this.$emit('input', e);
    },
  },
}
</script>

<style lang="scss">
@import "IBackupSalesforceStatusDropdown";
</style>
